var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SecondaryNavigationItem = function (_a) {
    var item = _a.item;
    return (_jsx("a", __assign({ href: item.href, target: "_blank", className: "group flex items-center rounded-md px-3 py-2 text-sm font-medium text-blue-100 hover:bg-blue-600 hover:bg-opacity-75" }, { children: _jsx("span", __assign({ className: "truncate" }, { children: item.name })) }), item.name));
};
export default SecondaryNavigationItem;
